import { render, staticRenderFns } from "./StatusQuotationGarantia.vue?vue&type=template&id=104e7943"
import script from "./StatusQuotationGarantia.vue?vue&type=script&lang=js"
export * from "./StatusQuotationGarantia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports